module.exports = __webpack_public_path__ + "static/media/00_eq_equantia.a892c1b1.jpg";